import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { SiaI18nService } from '../services/i18n.service';

@Component({
  selector: 'dialog-overview-example-dialog',
  template: ` <div mat-dialog-title>
      {{ data.title }}
    </div>

    <div
      mat-dialog-content
      [style]="'width: 100%; margin-bottom: 10px;' + (data.style ?? '')"
    >
      {{ data.text }}
    </div>
    <div style="display:flex; width:100%; justify-content:center">
      @if (!data.dataSet) {
        <mat-form-field>
          <input matInput [(ngModel)]="promptValue" />
        </mat-form-field>
      }
      @if (data.dataSet) {
        <mat-form-field>
          <mat-select [(value)]="promptValue">
            @for (option of data.dataSet; track option) {
              <mat-option [value]="option.id">{{
                option.description
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>

    <div
      mat-dialog-actions
      style="display: flex; justify-content: center; gap: 10px"
    >
      <button mat-raised-button color="warn" (click)="onCancelClick()">
        {{ this.translate('ANNULLA') }}
      </button>
      <button mat-raised-button color="primary" (click)="onConfirmClick()">
        {{ this.translate('CONFERMA') }}
      </button>
    </div>`,
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatInput,
    FormsModule,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
  ],
})
export class PromptDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<PromptDialogComponent>>(MatDialogRef);
  protected i18nService = inject(SiaI18nService);

  pageDataSetted: boolean = false;
  promptValue: string | undefined;

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  onCancelClick() {
    this.dialogRef.close(undefined);
  }

  onConfirmClick() {
    // this.data.result = true;
    this.dialogRef.close(this.promptValue);
  }
  translate(txt: string) {
    if (txt) {
      return this.i18nService.translate(txt);
    }
    return '';
  }
}
